<template>
	<v-row dense 
		style = "overflow-y 	:  auto;"	
		class = "pt-2"

	>
		<template 
			v-for = "(item_field, index_field) of list_fields"
		>
			<v-col
				:key 	= "index_field"
				:xl 	= "item_field.cols.xl ? item_field.cols.xl : 4"
				:lg 	= "item_field.cols.lg ? item_field.cols.lg : 4"
				:md 	= "item_field.cols.md ? item_field.cols.md : 4"
				:xs 	= "item_field.cols.xs ? item_field.cols.xs : 4"
				:cols 	= "item_field.cols.cols ? item_field.cols.cols : 4"
				:offset = "item_field.cols.offset"
				class 	= "caption"
				v-show  = "show[item_field.key]"

			>
				<!-- {{item_field}}- {{index_field}} -->
				<v-text-field
					dense
					outlined
					v-model 		= "inf[item_field.key]"
					type 			= "text"
					:label 			= "$ml.get(item_field.text)"
					:hide-details 	= "!item_field.counter_active"
					class 			= "pa-0"
					@input 			= "debounce_input(item_field.key, inf[item_field.key])"
					v-if 			= "item_field.type == 'text'"
					:disabled 		= "item_field.enable"		
					:placeholder	= "item_field.placeholder"
					:rules  		= "item_field.rules"
					:counter 		= "item_field.counter_active"
					:value 			= "item_field.value"
					v-show 			= "show[item_field.key]"
					:readonly 		= "item_field.is_read"
				>				
					<template slot = "prepend-inner">						
						<v-icon 
							small 
							v-text = "item_field.icon" 
							class  = "pt-1"
						></v-icon>
					</template>	
					<template v-slot:append-outer>
						<v-tooltip right>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									small
									class="ml-1"
									color="primary"
									v-on="on"
									v-bind="attrs"
								>mdi-information-outline</v-icon>
							</template>
							<span>{{ $ml.get(item_field.tooltip || item_field.text) }}</span>
						</v-tooltip>
					</template>
				</v-text-field>
				<v-text-field
					dense
					outlined
					v-model 		= "inf[item_field.key]"
					type 		 	= "text"
					:label 			= "$ml.get(item_field.text) + ' ' + item_field.text1"					
					:class 			= "['pa-0', rtsp_valid[item_field.key] ? 'ag-valid-field' : '']"
					@input 			= "debounce_input(item_field.key, inf[item_field.key])"
					v-if 			= "item_field.type == 'check'"					
					:messages 		= "messages_check[item_field.key] == 'RTSP Valid' ? 'RTSP Valid' : ''"
					:error-messages = "messages_check[item_field.key] == 'RTSP Not Valid' ? 'RTSP Not Valid' : ''"
					:color 			= "messages_check[item_field.key] == 'RTSP Valid' ? 'success' : ''"
					:placeholder 	= "'rtsp://example:pass@ip/'"
					v-show 			 = "show[item_field.key]"
					persistent-hint 
					
					:hint 			= "render_rtsp_hint(item_field)"
				>				
					<!-- :persistent-hint = "check_retransmission(item_field.key)" -->
				<!-- item_field.placeholder -->
					<!-- :hide-details 	= "$route.name == 'setting_device'" -->
					<!-- loading -->
					
					<template slot = "prepend-inner">						
						<v-icon 
							small 
							v-text = "item_field.icon" 
							class  = "pt-1"

						></v-icon>
					</template>	
					<template v-slot:append>	
					<!-- <v-fade-transition leave-absolute>					 -->
							
						<v-tooltip 
							bottom
							v-model = "rtsp_valid[item_field.key]"	
						>
						<template v-slot:activator = "{ on: tooltip }">
							<v-btn
								small
								:color = " rtsp_valid[item_field.key] ? 'primary' : 'secondary'"
								v-on   = "{ ...tooltip}"
								v-show = "!progress_connection[item_field.key] && $route.name == 'new_device'"
								@click = "start_stream(inf[item_field.key], item_field.key)"
								class  = "mx-2"
							>
									
									<!-- v-show = "!progress_connection" -->
								<v-icon 
									color  = "white"
									v-text = "item_field.icon1" 
									class  = "ml-0"
								></v-icon>
							</v-btn>
						</template>
							<span>
								{{ $ml.get('click_test_video')}}
							</span>
                		</v-tooltip>
						<v-progress-circular
				          indeterminate
				          v-show = "progress_connection[item_field.key]"				          
				          color  = "primary"
				          height = "4"
				          :size  = "25"
				          class  = mx-1
				        ></v-progress-circular>

				        <v-tooltip
							bottom
						>

							<template v-slot:activator = "{ on: tooltip }">
								<v-btn
									small
									v-on   = "{ ...tooltip}"
									:color = "retransmission[item_field.key] ? 'success' : 'secondary'"
									@click = "select_retransmission('channel_retransmission', item_field.key)"
									class  = "mr-1"
								>
									<v-icon
										color  = "white"
										v-text = "item_field.icon_retransmission"
										class  = "ml-0"
									></v-icon>
								</v-btn>
							</template>
							<span>
								{{ $ml.get('select_retransmission')}} <br>
								{{ render_name_retransmission_rtsp() }}
							</span>
                		</v-tooltip>
                		


				        <v-tooltip 
							bottom
						>
							
						<template v-slot:activator = "{ on: tooltip }">
							<v-btn
								small
								v-on   = "{ ...tooltip}"								
								:color = "record[item_field.key] ? 'error' : 'secondary'"
								@click = "select_record('channel_record', item_field.key)"
							>
									
									
								<v-icon 
									color  = "white"
									v-text = "item_field.icon_record" 
									class  = "ml-0"
								></v-icon>
							</v-btn>
						</template>
							<span>
								{{ $ml.get('select_record_rtsp')}}
							</span>
                		</v-tooltip>
				       	
					</template>
					<!-- </v-fade-transition> -->
					<!-- <v-fade-transition leave-absolute > -->
					<!-- </v-fade-transition> -->
					<!-- </template>	 -->
					<!-- <template v-slot:progress>
				        
				    </template> -->
				    <template slot = "message">	
				    	<template v-if = "item_field && item_field.key == 'rtsp' && inf && inf.rtsp_meta">
				    		<span class  = "primary--text font-weight-medium">
				    			{{ inf.rtsp_meta }}
				    		</span>
				    		<br>
				    	</template>
				    	<template v-if = "item_field && item_field.key == 'rtsp2' && inf && inf.rtsp2_meta">
				    		<span class  = "primary--text font-weight-medium">
				    			{{ inf.rtsp2_meta }}
				    		</span>
				    		<br>
				    	</template>
				    	<template v-if = "$route && $route.name == 'setting_device'"
				    		v-for = "(item_msg, idx_msg) of messages_rtsps"
				    	>
				    		
						    <v-tooltip 
								bottom
							>
									
								<template v-slot:activator = "{ on, attrs }">
									<span
										:class 	= "item_msg.class"
										v-on    = "on"
										v-bind = "attrs"
									>
										{{ item_msg.key }} 
									</span>			
								</template>
								<span>								
									{{ $ml.get(item_msg.tooltip) }}
								</span>
	                		</v-tooltip>
		               		{{ render_name_retransmission_rtsp(item_field, item_msg) }}
							<br> 
		                	
		               	</template>
				    </template>
					<template v-slot:append-outer>
						<v-tooltip right>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									small
									class="ml-1"
									color="primary"
									v-on="on"
									v-bind="attrs"
								>mdi-information-outline</v-icon>
							</template>
							<span>{{ $ml.get(item_field.tooltip || item_field.text) }}</span>
						</v-tooltip>
					</template>
				</v-text-field>
				<v-text-field
					dense
					outlined
					hide-details
					v-model 	= "inf[item_field.key]"					
					type 		= "password"
					:label 		= "$ml.get(item_field.text)"
					class 		= "pa-0"
					v-if 		= "item_field.type == 'password'"
					:disabled 	= "item_field.enable"		
					:value		= "item_field.value"

					v-show 			= "show[item_field.key]"
							
				>				
					<template slot = "prepend-inner">						
						<v-icon 
							small 
							v-text = "item_field.icon" 
						></v-icon>
					</template>
					<template v-slot:append-outer>
						<v-tooltip right>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									small
									class="ml-1"
									color="primary"
									v-on="on"
									v-bind="attrs"
								>mdi-information-outline</v-icon>
							</template>
							<span>{{ $ml.get(item_field.tooltip || item_field.text) }}</span>
						</v-tooltip>
					</template>
				</v-text-field>
				<v-text-field
					dense
					outlined
					hide-details
					v-model 	= "inf[item_field.key]"					
					type 		= "number"
					:label 		= "$ml.get(item_field.text)"
					class 		= "pa-0"
					v-if 		= "item_field.type == 'numberr'"
					:disabled 	= "item_field.enable"		
					:value		= "item_field.value"

							
				>				
					<!-- v-show 			= "show[item_field.key]" -->
					<template slot = "prepend-inner">						
						<v-icon 
							small 
							v-text = "item_field.icon" 
						></v-icon>
					</template>
					<template v-slot:append-outer>
						<v-tooltip right>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									small
									class="ml-1"
									color="primary"
									v-on="on"
									v-bind="attrs"
								>mdi-information-outline</v-icon>
							</template>
							<span>{{ $ml.get(item_field.tooltip || item_field.text) }}</span>
						</v-tooltip>
					</template>
				</v-text-field>
				<v-text-field
					dense
					outlined
					hide-details
					v-model.number  = "inf[item_field.key]"
					:type 			= "'number'"
					:label 			= "$ml.get(item_field.text)"
					v-else-if 		= "['number', 'capacity'].includes(item_field.type)"
					:placeholder	= "item_field.placeholder"
					v-show 			= "show[item_field.key]"

				>
				<!-- item_field.type == 'number' -->
					<v-icon						
						small
						slot   = "prepend-inner"
						color  = "primary"
						v-text = "item_field.icon"
						class  = "mt-1"
					></v-icon>
					<template v-slot:append>
			            <v-menu
			                offset-y
			            >
			                <!-- style  = "top: -12px" -->
			                <template v-slot:activator = "{ on, attrs }">
			                  <v-btn
			                    small
			                    v-bind = "attrs"
			                    v-on   = "on"
			                    color  = "blue"
			                    class  = "white--text"
			                  >
			                    
			                    {{ capacity }}
			                  </v-btn>
			                </template>
			                <v-list dense>
			                	<v-list-item-group 
					              	dense
					              	
					            >
					            	<template v-for = "(item_list, index_list) of list_capacity">
                
							            <v-list-item               
						                	dense
						                	:Key 	   = "index_list"
						                	v-if       = "item_list"                   
						                	@click     = "select_capacity(item_list)"
						                
						              	>           
							              	<v-list-item-content 
						                  		class = "pa-0 ma-0"
						                  	>
						                    	<v-list-item-title> 
						                    		{{ item_list.text}} 
						                   		</v-list-item-title>
						                  	</v-list-item-content>
				                	       
				            			</v-list-item>
				            		</template>  
					        	</v-list-item-group>
			                </v-list>
			              </v-menu>
			            </template>
					<template v-slot:append-outer>
						<v-tooltip right>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									small
									class="ml-1"
									color="primary"
									v-on="on"
									v-bind="attrs"
								>mdi-information-outline</v-icon>
							</template>
							<span>{{ $ml.get(item_field.tooltip || item_field.text) }}</span>
						</v-tooltip>
					</template>
					
				</v-text-field>

				<!-- <v-card 
					outlined 
					class 		= "pa-0 pb-1" 
					color 		= "secondary"
					v-else-if 	= "item_field.type == 'switch'"
				>
					
					<v-switch
						class 			= "mt-1"
						v-model 		= "inf[item_field.key]"			
						:label 			= "$ml.get(item_field.text)"
						hide-details
						outlined
						:prepend-icon 	= "item_field.icon"

					>
								slot   = "prepend-inner"	
						<template v-slot:icon>
							<v-icon														
								color  = "error"
								v-text = "item_field.icon"
							></v-icon>
						</template>
					</v-switch>
				</v-card> -->
				<v-select
					dense
					outlined
					hide-details
					v-model 		= "inf[item_field.key]"
					:label 			= "$ml.get(item_field.text)"
					:items 			= "item_field.items"
					v-else-if 		= "item_field.type == 'select'"
					@change 		= "render_shows"
					:item-text 		= "item_field.item_text"
					:item-value 	= "item_field.item_value"
					:return-object 	= "item_field.return_obj"
					:loading 		= "loadings[item_field.key]"
					:clearable 		= "item_field.clearable"
					:readonly 		= "item_field.is_read"
					
				>
					<!-- v-show 			= "show[item_field.key]" -->
					<!-- :prepend-inner-icon = "" -->
					<template v-slot:prepend-inner	 
					>
						<v-icon
							small
							class = "mt-1"
						>
							{{ item_field.icon }}
						</v-icon>
						
					</template>
					<template v-slot:append-outer>
						<v-tooltip right>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									small
									class="ml-1"
									color="primary"
									v-on="on"
									v-bind="attrs"
								>mdi-information-outline</v-icon>
							</template>
							<span>{{ $ml.get(item_field.tooltip || item_field.text) }}</span>
						</v-tooltip>
					</template>
				</v-select>
				<v-card 
					outlined 
					class 		= "pa-0 caption pb-1 d-flex align-center" 
					height 		= "40"
					v-show 		= "show[item_field.key]"
					v-else-if 	= "item_field.type == 'switch'">
					<v-switch			
						dense						
						hide-details
						class 			= "mt-1 flex-grow-0"			
						v-model 		= "inf[item_field.key]"									
						:label 			= "$ml.get(item_field.text)"
						:prepend-icon 	= "item_field.icon"
					></v-switch>
					<v-tooltip right>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-2"
								color="primary"
								v-on="on"
								v-bind="attrs"
							>mdi-information-outline</v-icon>
						</template>
						<span>{{ $ml.get(item_field.tooltip || item_field.text) }}</span>
					</v-tooltip>
						<!-- :value 			= "item_field.value" -->
						<!-- v-if="item_field.type == 'switch'"						 -->
						<!-- class="pt-0" -->
				</v-card>
				<template 
					v-else-if = "item_field.type == 'btn'"
				>
					
						<!-- v-text 	= "$ml.get(item_field.text)"	 -->
					<v-btn
						
						color 	= "primary"
						@click 	= "actions_fields(item_field.action, item_field)"
						v-show  = "!loading_btn"
					>
					<!-- action_info.button -->
						<v-icon
							v-if 	= "item_field.icon"						
							:color 	= "item_field.icon_color"
							
						>
							{{ item_field.icon }}
						</v-icon>
						<span
							v-show = "item_field.text"
						>
							{{ item_field.text}}	
						</span>
						
					</v-btn>				
					<v-progress-circular
				        indeterminate
				        v-show = "loading_btn"				          
				        color  = "primary"
				        height = "4"
				        :size  = "25"
				        class  = mx-1
			        ></v-progress-circular>
				</template>
			</v-col>
		</template>
		<v-col
			cols 	= "6"
			v-show 	= "show.details"
		>
			<v-divider></v-divider>
			<v-card
				outlined
			>
				<v-card-title
					class = "caption pa-0 primary pl-1"
				>
					<v-chip
						label
						x-small
					>
						{{ details.title }}
					</v-chip>
				</v-card-title>
				<v-card-text
					class = "pa-1 pl-2"
				>
					<v-row
						no-gutters
					>
							
						<template 
							v-for = "(item_detail, key_detail, index_detail) of details.info"
						>
							<v-col
								cols = "4"
							>
								
								<span>
									{{ key_detail }} 
								</span> 
							</v-col>
							<v-col
								cols = "8"
							>
								<span>
									: {{ item_detail}}
								</span>
							</v-col>
						</template>						
					</v-row>
					<v-divider></v-divider>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
						<v-btn
							small
							:color 		= "details.color"
							@click 		= "test_peripheral()"
							:loading 	= "details.loading"
							v-show 		= "show.btn_peripheral"
						>
							<!-- v-show 		= "!details.loading" -->
							<v-icon
								x-small
							>
								{{ details.icon }}
							</v-icon>
							<span>
								{{ details.btn_text }}
							</span>						
						</v-btn>
					<v-spacer></v-spacer>

				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>
<style scoped = "scoped">
	.v-input--selection-controls {
     margin-top: 8px; 
    /* padding-top: 4px; */
}
/* Borde verde cuando RTSP es válido (aplicado a v-text-field outlined) */
.ag-valid-field >>> .v-input__slot,
.ag-valid-field /deep/ .v-input__slot,
.ag-valid-field ::v-deep .v-input__slot{
	border-color: #4caf50 !important;
}
.ag-valid-field >>> .v-input__slot fieldset,
.ag-valid-field /deep/ .v-input__slot fieldset,
.ag-valid-field ::v-deep .v-input__slot fieldset{
	border-color: #4caf50 !important;
}
</style>
<script>
	import { debounce } from '@/helpers/debounce.js'
	import EventBus 	from '@/event-bus'
	export default{
		name: 'input_fields',
		props: [ 
				'input_info',
				'action_info',
				'set_info',	
				'is_edit' // : false, // to desactive bus start	
			],
			/*
			input_info:
				[
					{
						key: 'name',
						text: 'name',
						type: 'text', || [ text , number, select, switch]		
						items: [], // if -> select 
						cols:
							{  // else cols -> 4
								xl: 4, 
								lg: 4,
								md: 4,
								xs: 5,
								cols: 5
							}
					},
				]
				*************
				key: 'btn',
						text: 'save',
						type: 'btn',
						size: 'small',
						icon: 'mdi-content-save',
						icon_size: 'small',
						icon_color: 'success',

						cols:
							{ 
								xl: 1, 
								lg: 1,
								md: 1,
								xs: 2,
								cols: 2
							}	
			*/
		data: (vm) => ({
			inf 			: {},
			list_fields 	: [],
			medium_original_items: ['USB','TCP', 'GPIO', 'HTTP'],
			messages_check 	: {
				rtsp  : '',
				rtsp2 : '',
			}, 
			timer_out 		: null, 
			
			progress_connection	: {
				rtsp  : false,
				rtsp2 : false
			},
			colors 			: {
				field 	: '', 
				check 	: '',
			},
			limit_conv 		: false,
			rtsp_valid 		: {
				rtsp  	: false,
				rtsp2 	: false
			},
			streaming_on 	: '',
			record  		: {				
				rtsp  	: false,
				rtsp2 	: false
			},
			retransmission 	: {
				rtsp  	: false,
				rtsp2 	: false
			},
			capacity 		: 'mb',
			list_capacity 	: [
				{
					key 	: 'mb',
					text 	: 'MB'
				},
				{
					key 	: 'gb',
					text 	: 'GB'
				}
			],
			show 			: {
				// details 	 : false,		
				btn_peripheral 	: true,

			},
			details 		: {
				title 		: vm.$ml.get("arduino"),
				info  		: null,
				btn_text 	: vm.$ml.get('test_peripheral'),
				icon 		: "mdi-clipboard-search",
				color 		: "success",
				loading 	: false,
			},
			loading_btn 	: false,
			loadings  		: {},
			messages_rtsps 	: [
				{
					key 	: "local",
					action 	: "local",
					tooltip : "msg_local_rtsp",
					class 	: "success--text font-weight-medium text-uppercase"
				},
				{
					key 	: "hls",
					action 	: "hls",
					tooltip : "msg_hls",	
					class 	: "warning--text font-weight-medium text-uppercase"

				},
			],
			
		}), // data

		created(){

			if (this.input_info && this.input_info.length > 0) {
				this.list_fields = [...this.input_info];
			}
			this.render_show_fields(this.set_info);
			if (this.set_info) {
				this.render_info(this.set_info);
			}else if (this.$route.name == 'new_device'){
				this.render_info(this.inf);
			}else if (this.$route.name == 'new_peripheral'){
				
				this.render_info(this.inf);
			}

			// Escuchar eventos de add_new_device para mostrar estado de carga automático
			if (!this.is_edit && this.$route.name == 'new_device') {
				// Handler para res_new_device (solo se crea una vez)
				this.res_new_device_handler = (res) => {
					// Desactivar loading de rtsp2 cuando termine la carga
					if (this.progress_connection && this.progress_connection['rtsp2']) {
						this.progress_connection['rtsp2'] = false;
					}
				};
				EventBus.$on('res_new_device', this.res_new_device_handler);

				// Handler para add_new_device
				this.add_new_device_handler = (action) => {
					// Si el evento viene con channel: 'rtsp2', establecer loading para rtsp2
					if (action && action.channel === 'rtsp2' && action.rtsp) {
						// Verificar que el rtsp coincide con el valor actual de rtsp2
						const currentRtsp2 = this.inf && this.inf.rtsp2;
						if (currentRtsp2 === action.rtsp) {
							this.progress_connection['rtsp2'] = true;
						}
					}
				};
				EventBus.$on('add_new_device', this.add_new_device_handler);
			}
			
		}, // created

		
		
		watch: {
			set_info: function(val) {
				// handler(val){
					console.log(val, 'info item_field ************************* watch limit')
					/*if (val.limit && this.limit_conv == false) {
						val.limit = parseInt(val.limit) / 1000000;
						console.log(val.limit, "***************************************** watch LIMIT")
						this.limit_conv = true;
					}*/
					
					if (val) {
						this.render_info(val);
					}
				// }, deep: true,
			}, // action info

			action_info: function (action){				
				if (action == 'save') {
					console.log('step 2 watch');
					this.actions_fields(action);
				}else if (action == 'update') {
					this.actions_fields(action);
				}else if (action == 'update_fields') {
					// Cuando la acción es update_fields, actualizar solo campos específicos sin perder estado
					if (this.set_info) {
						// Solo actualizar los campos que vienen en set_info, preservando todos los demás
						Object.keys(this.set_info).forEach(key => {
							this.$set(this.inf, key, this.set_info[key]);
						});
						// Limpiar la acción después de actualizar
						this.$nextTick(() => {
							if (this.$parent && this.$parent.action_to_field) {
								this.$parent.action_to_field.action = '';
							}
						});
					}
				}
			}, // action_info
			input_info : function(val){
				if (val) {
					this.list_fields = [...val]
				}

			}, // input info
			'inf.medium': function(newVal) {
				// Cuando cambia el medium y es arduino, ocultar ip si es USB
				if (this.inf && this.inf.type_peripheral === 'arduino') {
					if (newVal && newVal.toUpperCase() === 'USB') {
						this.show.ip = false;
					} else if (newVal && newVal.toUpperCase() === 'TCP') {
						this.show.ip = true;
					}
				}
			}, // medium
			'inf.type': function(newVal) {
				// Ocultar medium cuando el tipo es IP_CAM
				if (newVal === 'IP_CAM') {
					this.show.medium = false;
				}
			}, // type
			'inf.type_peripheral': function(newVal, oldVal) {
				// Si cambió el tipo de periférico, limpiar campos específicos y establecer valores por defecto
				if (oldVal && oldVal !== newVal) {
					// Limpiar campos que no son comunes a todos los tipos
					this.$set(this.inf, 'serial', '');
					this.$set(this.inf, 'ip', '');
					this.$set(this.inf, 'relay', null);
					this.$set(this.inf, 'arduino', null);
					this.$set(this.inf, 'username', '');
					this.$set(this.inf, 'password', '');
					this.$set(this.inf, 'token', '');
					this.$set(this.inf, 'host', '');
					this.$set(this.inf, 'pin', '');
					
					// Forzar actualización del campo medium para asegurar reactividad
					this.$nextTick(() => {
						const mediumField = this.list_fields.find(field => field.key === 'medium');
						if (mediumField && oldVal === 'iot_relay' && newVal !== 'iot_relay') {
							// Si se cambió desde iot_relay, restaurar opciones originales
							mediumField.items = [...this.medium_original_items];
						}
					});
				}

				if (newVal === 'siren') {
					// siren: name, UUID, medium
					this.show.name = true;
					this.show.deviceId = true; // UUID
					// Encontrar el campo medium y modificar sus items
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						mediumField.items = ['HTTP'];
						// Establecer el valor automáticamente
						this.$set(this.inf, 'medium', 'HTTP');
						// No mostrar medium si es IP_CAM
						if (this.inf.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
					}
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
					this.show.relay = false;
					this.show.arduino = false;
					this.show.serial = false;
					this.show.ip = false;
				} else if (newVal === 'arduino') {
					// arduino: name, UUID, medium, arduino
					this.show.name = true;
					this.show.deviceId = true; // UUID
					// Para arduino solo USB y TCP disponibles
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						mediumField.items = ['USB', 'TCP'];
						// Establecer el valor automáticamente a USB por defecto
						this.$set(this.inf, 'medium', 'USB');
						// No mostrar medium si es IP_CAM
						if (this.inf.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
					}
					this.show.arduino = true;
					// Si el medium es USB, ocultar ip
					if (this.inf.medium && this.inf.medium.toUpperCase() === 'USB') {
						this.show.ip = false;
					} else if (this.inf.medium && this.inf.medium.toUpperCase() === 'TCP') {
						this.show.ip = true;
					}
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
					this.show.relay = false;
					this.show.serial = false;
				} else if (newVal === 'iot_relay') {
					// iot_relay: name, UUID, medium, ip, serial
					this.show.name = true;
					this.show.deviceId = true; // UUID
					// Para iot_relay solo TCP disponible
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						mediumField.items = ['TCP'];
						// Establecer el valor automáticamente
						this.$set(this.inf, 'medium', 'TCP');
						// No mostrar medium si es IP_CAM
						if (this.inf.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
					}
					this.show.ip = true;
					this.show.serial = true;
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.arduino = false;
					this.show.relay = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
					// Emitir evento para abrir modal de relays en el componente padre
					this.$emit('open_relay_modal');
				} else if (newVal === 'electronic_lock') {
					// electronic_lock: name, UUID, user, password, token, host
					this.show.name = true;
					this.show.deviceId = true; // UUID
					// Ocultar medium cuando es electronic_lock
					this.show.medium = false;
					// Limpiar medium
					this.$set(this.inf, 'medium', '');
					// Limpiar campos de otros tipos
					this.$set(this.inf, 'serial', '');
					this.$set(this.inf, 'ip', '');
					this.$set(this.inf, 'relay', null);
					this.$set(this.inf, 'arduino', null);
					this.$set(this.inf, 'pin', '');
					// Mostrar campos de electronic_lock
					this.show.username = true;
					this.show.password = true;
					this.show.token = true;
					this.show.host = true;
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.relay = false;
					this.show.arduino = false;
					this.show.serial = false;
					this.show.ip = false;
				} else if (newVal === 'odroid') {
					// odroid: UUID, medium (ocultar name)
					this.show.name = false;
					this.show.deviceId = true; // UUID
					// Para odroid el medium es USB
					this.$set(this.inf, 'medium', 'USB');
					if (this.inf.type !== 'IP_CAM') {
						this.show.medium = true;
					} else {
						this.show.medium = false;
					}
					// Limpiar campos de otros tipos
					this.$set(this.inf, 'serial', '');
					this.$set(this.inf, 'ip', '');
					this.$set(this.inf, 'relay', null);
					this.$set(this.inf, 'arduino', null);
					this.$set(this.inf, 'username', '');
					this.$set(this.inf, 'password', '');
					this.$set(this.inf, 'token', '');
					this.$set(this.inf, 'host', '');
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
					this.show.relay = false;
					this.show.arduino = false;
					this.show.ip = false;
					this.show.serial = false;
				} else {
					// Restaurar las opciones originales si no es siren, arduino ni iot_relay
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						// Restaurar siempre las opciones originales cuando cambia a otro tipo
						// Verificar si las opciones fueron modificadas (no coinciden con las originales)
						const currentItems = mediumField.items || [];
						const originalItemsStr = this.medium_original_items.sort().join(',');
						const currentItemsStr = [...currentItems].sort().join(',');
						
						// Si viene de iot_relay o las opciones no coinciden, restaurar
						if (oldVal === 'iot_relay' || currentItemsStr !== originalItemsStr) {
							mediumField.items = [...this.medium_original_items];
						}
					}
					// Mostrar medium para otros tipos, excepto IP_CAM
					if (this.inf.type !== 'IP_CAM') {
						this.show.medium = true;
					} else {
						this.show.medium = false;
					}
					// Limpiar campos específicos de otros tipos
					this.$set(this.inf, 'relay', null);
					this.$set(this.inf, 'arduino', null);
					this.$set(this.inf, 'username', '');
					this.$set(this.inf, 'password', '');
					this.$set(this.inf, 'token', '');
					this.$set(this.inf, 'host', '');
					// Ocultar campo relay
					this.show.relay = false;
					// Ocultar campos de electronic_lock
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
				}
				
				// Forzar actualización de la vista después de cambiar el tipo
				this.$nextTick(() => {
					this.updateValidationState();
				});
			}, // type_peripheral

			/*inf : function(val){
				if (val && val.name && val.name.length >= 4 ) {
					// && this.messages_check.rtsp == "RTSP Valid"
					this.$emit('checking_rtsp', false);
				}else{
					this.$emit('checking_rtsp', true);
				}
				if (val.rtsp == '') {
					this.$emit('checking_rtsp', true);					
				}
			}, // inf*/

		}, // watch
		methods: {
			updateValidationState(){
				try{
					if (!(this.$route && this.$route.name == 'new_device')) return;
					const rtspVal  = (this.inf && this.inf.rtsp)  ? this.inf.rtsp  : '';
					const rtsp2Val = (this.inf && this.inf.rtsp2) ? this.inf.rtsp2 : '';
					if (rtspVal) {
						if (this.check_rtsp(rtspVal)){
							this.messages_check.rtsp = "RTSP Valid";
							this.rtsp_valid.rtsp = true;
						}else{
							this.messages_check.rtsp = "RTSP Not Valid";
							this.rtsp_valid.rtsp = false;
						}
					}else{
						this.messages_check.rtsp = '';
						this.rtsp_valid.rtsp = false;
					}
					if (rtsp2Val) {
						if (this.check_rtsp(rtsp2Val)){
							this.messages_check.rtsp2 = "RTSP Valid";
							this.rtsp_valid.rtsp2 = true;
						}else{
							this.messages_check.rtsp2 = "RTSP Not Valid";
							this.rtsp_valid.rtsp2 = false;
						}
					} else {
						this.messages_check.rtsp2 = '';
						this.rtsp_valid.rtsp2 = false;
					}
					const formReady = this.check_rtsp(rtspVal) && (this.inf && this.inf.name && this.inf.name.length >= 3);
					this.$emit('checking_rtsp', !formReady);
				}catch(e){
					// ignore
				}
			},
			render_rtsp_hint(item_field){
				try{
					let meta = '';
					if (item_field && item_field.key == 'rtsp') {
						meta = this.inf && this.inf.rtsp_meta ? this.inf.rtsp_meta : '';
					}else if (item_field && item_field.key == 'rtsp2'){
						meta = this.inf && this.inf.rtsp2_meta ? this.inf.rtsp2_meta : '';
					}
					const retrans = this.render_name_retransmission_rtsp(item_field);
					return [meta, retrans].filter(Boolean).join('  |  ');
				}catch(e){
					return this.render_name_retransmission_rtsp(item_field);
				}
			},
			actions_fields(act, item){
				// console.log(act, 'actions_fields')
				let info_up = null;
				
				if (act == 'save') {			
					// console.log('step 3, fields');		
					info_up = this.inf;
					/*if (info_up.limit) {
						info_up.limit = String(info_up.limit * 1000000);
					}*/
					// this.limit_conv = false;
					this.$emit('recive_info_field', { value: info_up, action: 'save'});
					// this.inf = {};
				}else if (act == 'update') {					

					info_up = this.inf;
					/*if (info_up.limit) {
						info_up.limit = String(info_up.limit * 1000000);
					}*/
					// this.limit_conv = false
					this.$emit('recive_info_field', { value: info_up, action: 'update'});
					// this.inf = {};
				}else if (act == "test_peripheral"){
					console.log("TEST new_peripheral : ", item);
					// this.test_peripheral(item);
				}

			}, // actions

			render_info(val){
			
				if (val) {
					// Si la acción es update_fields, solo actualizar campos específicos y salir temprano
					// Esto evita que se ejecute el resto de la lógica que podría sobrescribir campos
					if (this.action_info === 'update_fields') {
						Object.keys(val).forEach(key => {
							this.$set(this.inf, key, val[key]);
						});
						return; // Salir temprano para no ejecutar el resto de la lógica
					}

					if (val.limit !== undefined && val.limit !== null && val.limit !== '') {
						// Evitar reconvertir cuando el valor ya está en unidades de UI (MB/GB).
						// Solo convertir si "parece" bytes (string grande o número >= 1 unidad en bytes).
						const temp_cap = val.capacity ? val.capacity : 'mb';
						const numLimit = Number(val.limit);
						const isNumeric = !isNaN(numLimit);
						const bytesThreshold = temp_cap === 'gb' ? 1073741824 : 1048576; // 1 GB o 1 MB en bytes
						const looksLikeBytes = (typeof val.limit === 'string' && /^\d+(\.\d+)?$/.test(val.limit)) || (isNumeric && numLimit >= bytesThreshold);
						if (looksLikeBytes) {
							val.limit = this.$Helper.convert_capacity(temp_cap, numLimit, false, true); 
						}
						this.capacity = temp_cap;
					}
					if (val.channel_retransmission) {
						this.retransmission[val.channel_retransmission] = true; 
					}
					if (val.type_peripheral == "arduino") {
						this.get_arduinos();
						if (val.arduino) {
							let temp = null;
							if (typeof val.arduino == "string") {
								temp = this.$Helper.to_object(val.arduino);
								if (typeof temp == "string") {
									temp = this.$Helper.to_object(temp);
								}
								if (temp) {
									val.arduino = temp;
									this.show.details = true;
									this.details.info = temp;
								}
							}
						}
					}
					if (this.$route && this.$route.name == "setting_device") {
						this.show.btn_peripheral = false;
					}
					if (val.channel_record) {
						this.record[val.channel_record] = true;
						
					}else{
						if (this.$route.name == 'new_device'){
							this.inf.limit 		= 10;
							this.inf.is_record 	= true;
							this.inf.user 		= "admin";
							this.inf.password	= "admin";
							this.inf.is_motion  = false; 
							this.inf.video_for_display = true;
							this.inf.ip_machine = "127.0.0.1";
							this.inf.image 		= "jcaltamare/ebenezermotion:latest";

						}
						this.select_record('channel_record','rtsp');	
						// this.select_retransmission('channel_retransmision','rtsp');	


					}

					if (!val.capacity) {
						val.capacity 	= this.capacity;

					}
					
					// Si el dispositivo es PERIPHERAL, usar ip_machine solo si ip está vacío o null
					if (val && val.type === 'PERIPHERAL') {
						if (!val.ip || val.ip === '' || val.ip === null) {
							if (val.ip_machine) {
								val.ip = val.ip_machine;
							}
						}
					}
					
					// Reemplazar completamente el objeto inf
					this.inf = val;
					
					// Manejar campos según type_peripheral después de asignar valores
					if (val.type_peripheral === 'siren') {
						// siren: name, UUID, medium
						this.show.name = true;
						this.show.deviceId = true; // UUID
						if (val.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
						// Ocultar campos no necesarios
						this.show.mode = false;
						this.show.pin = false;
						this.show.arduino = false;
						this.show.ip = false;
						this.show.serial = false;
						this.show.relay = false;
						this.show.username = false;
						this.show.password = false;
						this.show.token = false;
						this.show.host = false;
					} else if (val.type_peripheral === 'electronic_lock') {
						// electronic_lock: name, UUID, user, password, token, host
						this.show.name = true;
						this.show.deviceId = true; // UUID
						this.show.username = true;
						this.show.password = true;
						this.show.token = true;
						this.show.host = true;
						// Ocultar campos no necesarios
						this.show.medium = false;
						this.show.mode = false;
						this.show.pin = false;
						this.show.arduino = false;
						this.show.ip = false;
						this.show.serial = false;
						this.show.relay = false;
					} else if (val.type_peripheral === 'arduino') {
						// arduino: name, UUID, medium, arduino
						this.show.name = true;
						this.show.deviceId = true; // UUID
						if (val.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
						this.show.arduino = true;
						// Para arduino solo USB y TCP disponibles
						const mediumField = this.list_fields.find(field => field.key === 'medium');
						if (mediumField) {
							mediumField.items = ['USB', 'TCP'];
						}
						// Establecer medium a USB si no está establecido o no es USB/TCP
						if (!val.medium || !['USB', 'TCP'].includes(val.medium)) {
							this.$set(this.inf, 'medium', 'USB');
						}
						// Si el medium es USB, ocultar ip
						if (val.medium && val.medium.toUpperCase() === 'USB') {
							this.show.ip = false;
						} else if (val.medium && val.medium.toUpperCase() === 'TCP') {
							this.show.ip = true;
						}
						// Ocultar campos no necesarios
						this.show.mode = false;
						this.show.pin = false;
						this.show.serial = false;
						this.show.relay = false;
						this.show.username = false;
						this.show.password = false;
						this.show.token = false;
						this.show.host = false;
					} else if (val.type_peripheral === 'iot_relay') {
						// iot_relay: name, UUID, medium, ip, serial
						this.show.name = true;
						this.show.deviceId = true; // UUID
						if (val.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
						this.show.ip = true;
						this.show.serial = true;
						// Para iot_relay solo TCP disponible
						const mediumField = this.list_fields.find(field => field.key === 'medium');
						if (mediumField) {
							mediumField.items = ['TCP'];
						}
						// Establecer medium a TCP si no está establecido o es diferente
						if (!val.medium || val.medium !== 'TCP') {
							this.$set(this.inf, 'medium', 'TCP');
						}
						// Ocultar campos no necesarios
						this.show.mode = false;
						this.show.pin = false;
						this.show.arduino = false;
						this.show.relay = false;
						this.show.username = false;
						this.show.password = false;
						this.show.token = false;
						this.show.host = false;
						// Obtener lista de relays si no hay datos
						if (!val.relay) {
							this.get_relays();
						}
					} else if (val.type_peripheral === 'odroid') {
						// odroid: UUID, medium (ocultar name)
						this.show.name = false;
						this.show.deviceId = true; // UUID
						if (val.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
						// Para odroid el medium es USB
						if (!val.medium || val.medium !== 'USB') {
							this.$set(this.inf, 'medium', 'USB');
						}
						// Ocultar campos no necesarios
						this.show.mode = false;
						this.show.pin = false;
						this.show.arduino = false;
						this.show.ip = false;
						this.show.serial = false;
						this.show.relay = false;
						this.show.username = false;
						this.show.password = false;
						this.show.token = false;
						this.show.host = false;
					} else {
						// No mostrar medium si es IP_CAM
						if (val.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
						this.show.username = false;
						this.show.password = false;
						this.show.token = false;
						this.show.host = false;
					}
					
					// Ocultar medium cuando el tipo es IP_CAM (verificación final)
					if (val.type === 'IP_CAM') {
						this.show.medium = false;
					}
					
					this.updateValidationState();
					this.$nextTick(() => {
						this.updateValidationState();
					});
				}
			}, // render info

			debounce_input(val, newVal){
				let vm = this;
				if (this.$route.name == 'new_peripheral') {
				        		// vm.start_stream(newVal);
					console.log("enter here")
					vm.messages_check[val] = "RTSP Valid";
				    vm.$emit('checking_rtsp', false);			
				    vm.rtsp_valid[val] = true;
					return true;
				}	
				// let timeoutID = null
					// console.log('checking *******************', val)
					// let arr = [];
				/*clearTimeout(timeoutID)
				    let args = arguments
				    let that = this
				    timeoutID = setTimeout(function (arr) {
				      arr.apply(that, args)
				    }, 500)*/

				
				clearTimeout(this.timer_out);
				this.timer_out = setTimeout( () => {
			        // this.debouncedInput = newVal			        
			        // vm.inf[val] = newVal;
					
			        if (newVal == '') {
			        	vm.messages_check[val] = '';
			        }else{

				        if (vm.check_rtsp(newVal)){
				        	vm.messages_check[val] = "RTSP Valid";
				        	if (this.$route.name == 'new_device') {
				        		const formReady = vm.check_rtsp(vm.inf.rtsp || '') && (vm.inf.name && vm.inf.name.length >= 3);
				        		vm.$emit('checking_rtsp', !formReady);
				        	}else{
				        		vm.$emit('checking_rtsp', false);
				        	}
				        	if (this.$route.name == 'new_device') {
				        		// vm.start_stream(newVal);
				        		vm.rtsp_valid[val] = true;
				        	}
				        	
				        } else{
				        	if (this.$route.name == 'new_device') {
				        		// vm.start_stream(newVal);
				        		vm.rtsp_valid[val] = false;
				        	}
				        	vm.messages_check[val] = "RTSP Not Valid";
				        	const formReady = vm.check_rtsp(vm.inf.rtsp || '') && (vm.inf.name && vm.inf.name.length >= 3);
				        	vm.$emit('checking_rtsp', !formReady);
				        	if (vm.inf.rtsp && vm.messages_check && vm.messages_check.rtsp) {
				        		const ready2 = vm.check_rtsp(vm.inf.rtsp || '') && (vm.inf.name && vm.inf.name.length >= 3);
				        		vm.$emit('checking_rtsp', !ready2);
				        	}
				        }
			        }
			        clearTimeout(vm.timer_out);
			      }, 800) // 500
			}, // debounce input

			check_rtsp(str_url){
				
				//rtsp:\/\/\w{1,20}:\w{1,20}@\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3} // no work
				//for multiple checks
				/*"^((https|http|ftp|rtsp|mms)?://)" 
				   + "([0-9a-z_! *'(), &=+$%-]+:)?" [0-9a-z_! *'(), =+$%-]+ *)?"//ftp user?" "@ 
				      + "(([0-9] {1,3}){3} [0-9] {1,3}"// IP form URL - 199.194.52.184 
				      + "|"// Allow IP and DOMAIN (domain name)
				      + "([0-9a-z_! *'()-]+_)*"//domain name - www. 
				      + "([0-9a-z] [0-9a-z-]{0,61})? [0-9a-z]"//secondary domain name 
				      + "[a-z]{2,6})" // first level domain- .com or .museum 
				      + "(: [0-9] {1,4})?"//Port-:80 
				      + "((/?)|" // a slash isn't required if there is no file name 
				      + "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";*/
				let strRegex = `(rtsp):\/\/([^\s@/]+)@([^\s/:]+)(?::([0-9]+))?(\/.*)` ;
				let strRegex1 = `rtsp:\/\/\w{1,20}:\w{1,20}@\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3`;
				let strRegex2 =  "(https?|rtsp|qvmc|rtmp):\\/\\/(?:([^\\s@\\/]+?)[@])?([^\\s\\/:]+)(?:[:]([0-9]+))?(?:(\\/[^\\s?#]+)([?][^\\s#]+)?)?([#]\\S*)?";
				// "(https?|rtsp|qvmc|rtmp):\/\/(?:([^\s@\/]+?)[@])?([^\s\/:]+)(?:[:]([0-9]+))?(?:(\/[^\s?#]+)([?][^\s#]+)?)?([#]\S*)?";
					let re=new RegExp(strRegex);
					let re1=new RegExp(strRegex1);
					let re2=new RegExp(strRegex2);
					/*//re.test()
					let check_valid = str_url.split(":");
					let check = true;
					if (check_valid[0] !== "rtsp") {
						check = false;
					}else{
						let temp = new RegExp(`[//]`);
						if (!temp.test(check_valid[0])) {
							check = false;
						}
					}*/
					
					// console.log(re.test(str_url) , re1.test(str_url));
					if (re.test(str_url) || re1.test(str_url) || re2.test(str_url)){
						return (true);
					}else{
						return (false);
					}
			}, // check rtsp
			start_stream(stream, key){
				if (!this.is_edit) {
					this.progress_connection[key] = true;
					if (this.streaming_on) {
						EventBus.$emit('close_stream', this.streaming_on);
					}
					
					this.streaming_on = stream;

					EventBus.$emit('add_new_device', {
						rtsp     : stream,
						deviceId : 'new_device' 
					})
					this.$EventBus.$on('res_new_device', (action) =>{
						this.progress_connection[key] = false;
					})
				}
			}, // start stream

			select_record(key, item){
				this.inf[key] 	  = item;
				this.record[item] = true;
				if (item == 'rtsp') {
					this.record['rtsp2'] = false;
				}else{
					this.record['rtsp']  = false;
				}
			}, // select record

			select_retransmission(key, item){
				if (this.inf[key] == item) {
					this.inf[key] 	  			= '';
					this.retransmission[item] 	= false;
				}else{

					this.inf[key] 	  			= item;
					this.retransmission[item] 	= true;
					if (item == 'rtsp') {
						this.retransmission['rtsp2'] = false;
					}else{
						this.retransmission['rtsp']  = false;
					}
				}
			},  // select_retransmission

			select_capacity(item){
				this.capacity = item.text;
				this.inf['capacity'] = item.key;
			}, // select capacity

			render_name_retransmission_rtsp(item, option){
				
				if (this.$route.name == 'setting_device') {
					// this.$server_rtsp
					// const { name, deviceId } 	= this.inf;
					let channel 				= 1; 
					if (item && item.key == "rtsp2") {
						channel = 2;
					}
					if (option && option.action == "local") {
						return  this.$Format.format_local_hls({ ...this.inf },  "local", channel);
					}else{
						return this.$Format.format_local_hls({ ...this.inf },  "hls", channel);
					}
				}
				return ''
			}, // render name retransmisison

			check_retransmission(key){
				if (this.retransmission[key]) {
					return true
				}
				return false

			}, // check restransmission

			render_show_fields(item){

				if (this.list_fields && this.list_fields.length > 0) {
					let type   = item && item.type 		? item.type  	: false ;
					let medium = item && item.medium 	? item.medium 	: false ;
					let type_peripheral = item && item.type_peripheral ? item.type_peripheral : (this.inf && this.inf.type_peripheral ? this.inf.type_peripheral : false);
					// console.log("CHECK TYPE ", type)
					this.list_fields.forEach((i)=>{

						this.show[i.key] 		= i["show"];
						this.loadings[i.key]	= false;
						
						// Si es odroid o electronic_lock y el campo es medium, mantenerlo oculto
						if (i.key === 'medium' && (type_peripheral === 'odroid' || type_peripheral === 'electronic_lock')) {
							this.show[i.key] = false;
						} else if (i.key === 'medium' && type === 'IP_CAM') {
							// Ocultar medium cuando es IP_CAM
							this.show[i.key] = false;
						} else if (i.key === 'image' || i.key === 'ip_machine') {
							// Ocultar image e ip_machine siempre
							this.show[i.key] = false;
						} else if (i && i.show_in) {
							if (i.show_in.includes(type)) {
								this.show[i.key] = true;
							}else{
								this.show[i.key] = false;

							}
						}
						// Ocultar mode y pin cuando es PERIPHERAL
						if (type === 'PERIPHERAL') {
							if (i.key === 'mode' || i.key === 'pin') {
								this.show[i.key] = false;
							}
						}
						
						if (i.key == 'pin') {
							if (["GPIO", "TCP"].includes(medium) && type !== 'PERIPHERAL') {
							// this.render_shows();
								this.show[i.key] = true;
							}	
						}
						if (i.key == "ip") {
							if (["TCP"].includes(medium) ) {
							
								this.show[i.key] = true;
							}	
						}
						if (i.key == 'serial') {
							if (item && item.serial) {
								this.show[i.key] = true;
							}
						}
					})

				}
				// console.log("SHOW ------------> ", this.show)
			}, // render_show_fields

			render_shows(key){
				// console.log("MEDIUM 1", this.inf)

				// Manejar el caso de siren - solo HTTP disponible
				if (this.inf && this.inf.type_peripheral === 'siren') {
					// siren: name, UUID, medium
					this.show.name = true;
					this.show.deviceId = true; // UUID
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						mediumField.items = ['HTTP'];
						// Establecer el valor automáticamente si no está establecido o es diferente
						if (!this.inf.medium || this.inf.medium !== 'HTTP') {
							this.$set(this.inf, 'medium', 'HTTP');
						}
					}
					// No mostrar medium si es IP_CAM
					if (this.inf.type !== 'IP_CAM') {
						this.show.medium = true;
					} else {
						this.show.medium = false;
					}
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.arduino = false;
					this.show.ip = false;
					this.show.serial = false;
					this.show.relay = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
				} else if (this.inf && this.inf.type_peripheral === 'arduino') {
					// arduino: name, UUID, medium, arduino
					this.show.name = true;
					this.show.deviceId = true; // UUID
					// Para arduino solo USB y TCP disponibles
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						mediumField.items = ['USB', 'TCP'];
						// Establecer el valor automáticamente a USB si no está establecido o no es USB/TCP
						if (!this.inf.medium || !['USB', 'TCP'].includes(this.inf.medium)) {
							this.$set(this.inf, 'medium', 'USB');
						}
						// No mostrar medium si es IP_CAM
						if (this.inf.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
					}
					this.show.arduino = true;
					// Si el medium es USB, ocultar ip
					if (this.inf.medium && this.inf.medium.toUpperCase() === 'USB') {
						this.show.ip = false;
					} else if (this.inf.medium && this.inf.medium.toUpperCase() === 'TCP') {
						this.show.ip = true;
					}
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.serial = false;
					this.show.relay = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
				} else if (this.inf && this.inf.type_peripheral === 'iot_relay') {
					// iot_relay: name, UUID, medium, ip, serial
					this.show.name = true;
					this.show.deviceId = true; // UUID
					// Para iot_relay solo TCP disponible
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						mediumField.items = ['TCP'];
						// Establecer el valor automáticamente si no está establecido o es diferente
						if (!this.inf.medium || this.inf.medium !== 'TCP') {
							this.$set(this.inf, 'medium', 'TCP');
						}
						// No mostrar medium si es IP_CAM
						if (this.inf.type !== 'IP_CAM') {
							this.show.medium = true;
						} else {
							this.show.medium = false;
						}
					}
					this.show.ip = true;
					this.show.serial = true;
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.arduino = false;
					this.show.relay = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
					// Obtener lista de relays disponibles
					if (!this.inf.relay) {
						this.get_relays();
					}
				} else if (this.inf && this.inf.type_peripheral === 'odroid') {
					// odroid: UUID, medium (ocultar name)
					this.show.name = false;
					this.show.deviceId = true; // UUID
					// Para odroid el medium es USB
					if (!this.inf.medium || this.inf.medium !== 'USB') {
						this.$set(this.inf, 'medium', 'USB');
					}
					if (this.inf.type !== 'IP_CAM') {
						this.show.medium = true;
					} else {
						this.show.medium = false;
					}
					// Ocultar campos no necesarios
					this.show.mode = false;
					this.show.pin = false;
					this.show.arduino = false;
					this.show.ip = false;
					this.show.serial = false;
					this.show.relay = false;
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
				} else if (this.inf && this.inf.type_peripheral === 'electronic_lock') {
					// electronic_lock: name, UUID, user, password, token, host
					this.show.name = true;
					this.show.deviceId = true; // UUID
					this.show.username = true;
					this.show.password = true;
					this.show.token = true;
					this.show.host = true;
					// Ocultar campos no necesarios
					this.show.medium = false;
					this.show.mode = false;
					this.show.pin = false;
					this.show.arduino = false;
					this.show.ip = false;
					this.show.serial = false;
					this.show.relay = false;
				} else if (this.inf && this.inf.type_peripheral && this.inf.type_peripheral !== 'siren' && this.inf.type_peripheral !== 'arduino' && this.inf.type_peripheral !== 'iot_relay' && this.inf.type_peripheral !== 'odroid' && this.inf.type_peripheral !== 'electronic_lock') {
					// Restaurar las opciones originales si no es siren, arduino, iot_relay, odroid ni electronic_lock
					const mediumField = this.list_fields.find(field => field.key === 'medium');
					if (mediumField) {
						// Restaurar si estaba limitado a HTTP, TCP único o a USB/TCP
						if ((mediumField.items.length === 1 && ['HTTP', 'TCP'].includes(mediumField.items[0])) ||
							(mediumField.items.length === 2 && mediumField.items.includes('USB') && mediumField.items.includes('TCP'))) {
							mediumField.items = [...this.medium_original_items];
						}
					}
					// Mostrar medium para otros tipos, excepto IP_CAM
					if (this.inf && this.inf.type !== 'IP_CAM') {
						this.show.medium = true;
					} else {
						this.show.medium = false;
					}
					// Ocultar campo relay
					this.show.relay = false;
					this.inf.relay = null;
					// Ocultar campos de electronic_lock
					this.show.username = false;
					this.show.password = false;
					this.show.token = false;
					this.show.host = false;
				}
				
				// Ocultar medium cuando el tipo es IP_CAM (verificación final)
				if (this.inf && this.inf.type === 'IP_CAM') {
					this.show.medium = false;
				}

				if (this.inf && this.inf["medium"]) {
					// console.log("MEDIUM 2" ,this.inf["medium"])
				
					if (this.inf["medium"]) {
						if (this.inf["medium"].toLowerCase() == "gpio"){
							this.show.pin = true;
							this.show.ip  = false;				

						}else
						if (this.inf["medium"].toLowerCase() == "tcp"){
							this.show.ip  = true;
							this.show.pin = true;
							if (["iot_relay", "odroid"].includes(this.inf["type_peripheral"])) {
								this.show.serial = true;
							}
						}else if (this.inf["medium"].toLowerCase() == "usb"){
							// Para USB, ocultar ip y pin
							this.show.pin = false;
							this.show.ip  = false;
							this.show.serial = false;
						}else{
							this.show.pin = false;
							this.show.ip  = false;
							this.show.serial = false;
						}
						
					}

				} 

				if (this.inf && this.inf.type_peripheral && this.inf.type_peripheral == "arduino" && !this.inf.arduino){ 				
					this.get_arduinos();
					this.show.arduino 	= true;
					
				}else if (this.inf && this.inf.type_peripheral && this.inf.type_peripheral != "arduino" && this.inf.type_peripheral != "iot_relay"){			
					this.show.details 	= false;
					this.inf.arduino 	= null;
					this.show.arduino 	= false;
					this.details.info	= null;
					this.show.relay 	= false;
					this.inf.relay 		= null;
				}else if (this.inf && this.inf.type_peripheral && this.inf.arduino){ 					
					this.show.details 	= true;
					this.details.info	= this.inf.arduino;
				}
			},  // render_shows

			get_arduinos(){
				const api 	= this.$URL + "/api/v1/get_peripherals_usb";
				let info_up = { ...this.inf };
				this.loadings.arduino = true;
				this.$axios.post(api, info_up).then(res => {
					this.loadings.arduino = false;

					if (res && res.data && res.data.length > 0) {
						// arduino
						if (this.list_fields && this.list_fields.length > 0) {

							this.list_fields.forEach((field)=>{
								if (field && field.key == "arduino") {
									field.items = res.data;
								}
							}) 
						}else{
							console.warn("Not found item for itare get arduino");
						}
					}
				}).catch(er => {
					this.loadings.arduino = false;
					console.warn("Error get arduinos ", er)
				})
			}, // get arduinos

			get_relays(){
				const api 	= this.$URL + "/api/v1/mqtt/relays/info?timeout=2";
				this.loadings.relay = true;
				this.$axios.get(api).then(res => {
					this.loadings.relay = false;

					if (res && res.data && res.data.success && res.data.data && res.data.data.relays && res.data.data.relays.length > 0) {
						// Formatear los relays para el select
						const relays = res.data.data.relays.map(relay => ({
							serial: relay.serial,
							ip: relay.ip,
							inputs: relay.inputs,
							relays: relay.relays,
							topics: relay.topics
						}));

						if (this.list_fields && this.list_fields.length > 0) {
							this.list_fields.forEach((field)=>{
								if (field && field.key == "relay") {
									field.items = relays;
								}
							}) 
						}else{
							console.warn("Not found item for iterate get relays");
						}
					}
				}).catch(er => {
					this.loadings.relay = false;
					console.warn("Error get relays ", er)
				})
			}, // get relays

			test_peripheral(){
					// console.log("TEST new_peripheral 2", item, this.inf)
				if (this.inf) {
					const api 	 =  this.$URL + "/api/v1/test_peripheral";
					let info_up  = { ...this.inf };
					this.details.loading = true;
					this.$axios.post(api, info_up).then(res =>{
						// console.log("RES TEST peripheral ", res);
						this.details.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type 	: "success",
							message : this.$ml.get('test_peripheral')
						})
					}).catch(er => {
						console.warn("Error test peripheral : ", er);
						this.details.loading = false;
						
						this.$EventBus.$emit('notifications_modal',{
							type 	: "error",
							message : this.$ml.get('test_peripheral')
						})
					});
				}else{
					console.warn("Required info for request of teste peripheral");
				}
			}, // test_peripheral

			
		}, //methods

		mounted(){
			
		}, // mounted

		beforeDestroy(){
			// Limpiar listeners de eventos
			if (this.add_new_device_handler) {
				EventBus.$off('add_new_device', this.add_new_device_handler);
			}
			if (this.res_new_device_handler) {
				EventBus.$off('res_new_device', this.res_new_device_handler);
			}
		}, // beforeDestroy

	}; 
</script>